import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  savedParks: [],
};

const savedParksSlice = createSlice({
  name: "savedParks",
  initialState,
  reducers: {
    toggleSavedPark: (state, action) => {
      const parkId = action.payload;
      const index = state.savedParks.indexOf(parkId);

      if (index > -1) {
        state.savedParks.splice(index, 1);
      } else {
        state.savedParks.push(parkId);
      }
    },
    setSavedParks: (state, action) => {
      // Replace the current state with the migrated data
      state.savedParks = [...state.savedParks, ...action.payload];
    },
  },
});

export const { toggleSavedPark, setSavedParks } = savedParksSlice.actions;

export const savedParksReducer = savedParksSlice.reducer;

export const getSavedParksSelector = (state) => state.savedParks.savedParks;
